export default "__VITE_ASSET__Cbr0DYqm__"